export enum CBTProgramWeekEightStep {
    ExposuresCompletionStep = 'exposures-completion',
    PuttingItAllTogetherStep = 'putting-it-all-together',
    WaysToFitTogetherStep = 'ways-to-fit-together',
    NowWhatStep = 'now-what',
    ThankYouStep = 'thank-you',
}

export enum CBTProgramWeekEightSurvey {
    ExposureCompletion1 = 'week-8-exposure-completion-1',
    ExposureCompletion2 = 'week-8-exposure-completion-2',
}
